/*
 * This file is part of the Det Norske Teatret application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React, { type ComponentProps } from 'react';
import './Text.scss';

interface TextProps {
  children?: string;
  dropcap?: boolean;
}

/**
 * This is the Text component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 */
function Text({ children = '', dropcap = false }: TextProps) {
  let decorations: ComponentProps<'div'> = { 'appear-text': 'true' };

  if (dropcap) {
    decorations = {
      ...decorations,
      dropcap: 'true',
    };
  }

  return (
    <div
      className="body-text text"
      dangerouslySetInnerHTML={{ __html: children }}
      {...decorations}
    />
  );
}

export default Text;
